// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import DesNavigateContentAsList from 'viewmodel/DesNavigateContentAsListViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
    import { EnableWhen } from 'js/hocCollection';
const AwButtonEnableWhen = EnableWhen(AwButton);
AwButtonEnableWhen.displayName = 'AwButtonEnableWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/AddPartToLibrariesService', () => import('js/AddPartToLibrariesService'));
registerDynImportEntry('js/desCatalogEventBus', () => import('js/desCatalogEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "data": {
        "searchBox": {
            "displayName": "{{i18n.searchlibrary}}",
            "type": "STRING",
            "requiredText": "{{i18n.searchlibrary}}"
        },
        "selectedLibraries": "",
        "enableAddButton": false,
        "folderId": ""
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        },
        "provider": {
            "type": "string"
        },
        "part": {
            "type": "string"
        },
        "catalogspaceid": {
            "type": "string"
        }
    },
    "lifecycleHooks": {},
    "dataProviders": {
        "loadLibraries": {
            "action": "listLibraries",
            "response": "{{data.librariesFound}}",
            "totalFound": "{{data.totalFound}}",
            "selectionModelMode": "multiple"
        }
    },
    "actions": {
        "reveal": {
            "actionType": "dataProvider",
            "method": "loadLibraries"
        },
        "listLibraries": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "searchInput": "{{data.searchBox.dbValue}}",
                            "collaborationSpaceId": "{{props.collaborationspaceid}}"
                        },
                        "query": "query listLibraries( $listLibrariesInput: ListLibrariesInput ) { listLibraries( listLibrariesInput: $listLibrariesInput) }",
                        "variables": {
                            "listLibrariesInput": {
                                "searchOptions": {
                                    "limit": 20,
                                    "skip": 0,
                                    "outputProperties": [
                                        "*"
                                    ]
                                }
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}",
                "loadBydefault": true
            },
            "outputData": {
                "totalFound": "data.data.listLibraries.totalCount",
                "librariesFound": "data.data.listLibraries.filterObj"
            },
            "events": {
                "success": [
                    {
                        "name": "usePartSuccess",
                        "eventData": {
                            "eventName": "usePartSuccess",
                            "eventData": "{{librariesFound}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "addPartsintoLibraries": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationSpaceId": "{{props.collaborationspaceid}}",
                            "catalogspaceid": "{{props.catalogspaceid}}"
                        },
                        "query": "mutation usePartsInLibraries( $usePartsInLibrariesInput: UsePartsInLibrariesInput ) { usePartsInLibraries( usePartsInLibrariesInput: $usePartsInLibrariesInput) }",
                        "variables": {
                            "usePartsInLibrariesInput": {
                                "part": "{{props.part}}",
                                "libraries": "{{data.selectedLibraries}}",
                                "provider": "{{props.provider}}",
                                "folderId": "{{data.folderId}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "partAddedToLibraries": "data.data.usePartsInLibraries"
            },
            "events": {
                "failure": [
                    {
                        "name": "desUsePartsInLibrariesFailure",
                        "eventData": {
                            "eventData": "{{partAddedToLibraries}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "desUsePartsInLibrariesSuccess",
                        "eventData": {
                            "eventData": "{{partAddedToLibraries}}"
                        }
                    }
                ]
            },
            "actionMessages": {
                "success": [
                    {
                        "message": "partAddToLibraryMsg"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "storeSelectedLibraries": {
            "actionType": "JSFunction",
            "method": "storeSelectedLibrariesData",
            "inputData": {
                "data": "{{data}}",
                "selectedLibraries": "{{parameters.eventData}}"
            },
            "deps": "js/AddPartToLibrariesService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/desCatalogEventBus"
        },
        "enableAddButton": {
            "actionType": "JSFunction",
            "method": "enableAddButton",
            "inputData": {
                "vmo": "{{data}}",
                "selectedObjects": "{{parameters.eventData}}"
            },
            "deps": "js/AddPartToLibrariesService"
        }
    },
    "messages": {
        "displayDesUsePartsInLibrariesSuccessMsg": {
            "messageType": "INFO",
            "messageText": "{{i18n.usePartsInLibrariesSuccessMsg}}"
        },
        "partAddToLibraryMsg": {
            "messageType": "INFO",
            "messageText": "{{i18n.partAddToLibraryMsg}}",
            "messageTextParams": [
                "{{data.selectedLibraries.length}}",
                "{{ctx.partName}}"
            ]
        }
    },
    "conditions": {
        "enableAddButton": {
            "expression": "data.enableAddButton === true"
        }
    },
    "onEvent": [
        {
            "eventId": "loadLibraries.selectionChangeEvent",
            "action": "storeSelectedLibraries",
            "inputArgs": {
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "desUsePartsInLibrariesSuccess",
            "action": "publishToACCEventBus",
            "inputArgs": {
                "eventName": "desUsePartsInLibrariesSuccess",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "getContainersDataProvider.selectionChangeEvent",
            "action": "enableAddButton",
            "inputArgs": {
                "eventData": "{{eventData.selectedObjects}}"
            }
        }
    ],
    "i18n": {
        "addButton": [
            "DesCatalogPartSummaryMessages"
        ],
        "usePartsInLibrariesSuccessMsg": [
            "DesCatalogPartSummaryMessages"
        ],
        "searchlibrary": [
            "DesCatalogPartSummaryMessages"
        ],
        "partAddToLibraryMsg": [
            "DesCatalogPartSummaryMessages"
        ]
    },
    "_viewModelId": "DesAddPartToLibrary",
    "_uniqueViewModelId": "DesAddPartToLibrary",
    "ctx": {
        "partName": {
            "type": "object"
        }
    }
};

    /*
    <aw-panel class="aw-layout-full">
  <aw-panel-body>
        <des-navigate-content-as-list accsessionid={{props.accsessionid}}
          collaborationspaceid={{props.collaborationspaceid}}
          containertype="library"
          containerid=""
          folderid="">
        </des-navigate-content-as-list>
  </aw-panel-body>
  <aw-panel-footer>
    <aw-button action="addPartsintoLibraries" class='small' button-type='accent-high-contrast' size='stretched'
      enable-when="conditions.enableAddButton">{{i18n.addButton}}</aw-button>
  </aw-panel-footer>
</aw-panel>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}  className="aw-layout-full">
        <AwPanelBody>
            <DesNavigateContentAsList accsessionid={AwParseService.instance( "props.accsessionid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} collaborationspaceid={AwParseService.instance( "props.collaborationspaceid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} containertype="library">
            </DesNavigateContentAsList>
        </AwPanelBody>
        <AwPanelFooter>
            <AwButtonEnableWhen action={actions.addPartsintoLibraries} className="small" buttonType="accent-high-contrast" size="stretched" enableWhen={AwParseService.instance( "conditions.enableAddButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                {AwParseService.instance( "i18n.addButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
            </AwButtonEnableWhen>
        </AwPanelFooter>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;